import { render, staticRenderFns } from "./CtrlNormalBtn.vue?vue&type=template&id=68bf0a92&scoped=true&"
import script from "./CtrlNormalBtn.vue?vue&type=script&lang=ts&"
export * from "./CtrlNormalBtn.vue?vue&type=script&lang=ts&"
import style0 from "./CtrlNormalBtn.vue?vue&type=style&index=0&id=68bf0a92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68bf0a92",
  null
  
)

export default component.exports